/** Where the mcper.io app lives on its host: the static home page owns `/`. Routes below are relative to it. */
/** The dashboard is at the root of its host (portal.mcper.io). */
export const MCPER_APP_BASE = '';

/** Routes of the mcper.io app (history router, clean URLs, no fragments). */
export enum McperRoute {
  Login = '/login',
  /** Not under /auth: nginx and the Vite dev server proxy that prefix to the server. */
  SignedIn = '/signed-in',
  Overview = '/',
  Setup = '/setup',
  Sites = '/sites',
  SignIns = '/sign-ins',
  /** Where an agent sends a person to sign in to one site: /sign-ins/<host>. */
  SignInSite = '/sign-ins/:site',
  Agents = '/agents',
  Calls = '/calls',
  Settings = '/settings',
  /** The consent page an agent opens to get the person's mcper.io address. */
  Authorize = '/authorize',
}
